import { TypeOffre } from '@/enum/TypeOffre'
import { ExportCatalogType } from '@/enum/ExportCatalogType'
import { AloBase, getDefaultAloBase } from './AloBase'
import { FluxCompressionMode } from '@/enum/FluxCompressionMode'
import { AloPersonne } from './AloPersonne'


export interface AloFlux extends AloBase {    
    ensId:number //Id de l'enseigne titulaire du flux
    bldId:number //Id du générateur de flux à utiliser
    tmoId:number|null //Id du modèle tarifaire à appliquer au flux (fonctionnalité réservée uniquement pour Darty pro)    
    flxIsPortage:boolean //Indique que le flux a été initialié depuis l'interface Darty v2.
    flxOffreTyp:TypeOffre //Combinaison de flags indiquant les offres exportées dans le flux
    flxCatalogTyp:ExportCatalogType //Le flux comporte-t-il un feed produit, un feed famille ou les deux
    flxPriorite:number //Priorité du flux, plus le nombre est grand plus il est prioritaire
    flxRestrictedFlag: string //Flags correspondant aux restrictions d'accès aux éléments qui composent le flux
    flcMercurialScope: string //Flags correspondant aux Inclusion des produits en mercuriale
    flcMercurialMode: string //Tarification des produits en mercuriale
    flxIsDisabled:boolean
    flxCompressionMode:FluxCompressionMode
    flcMinStockNb:number
    flcMinRtb:number
    flcExcludeRtbNullOn:boolean
    flcExcludePxbOn:boolean
    flcFiltreEntrepot:number
    flcFiltreSeg:number
    flcExcludedCodicStr:string
    flcParamMaxPhotos:number
    fspKey:string
    fspContactClient:string
    fspContactDarty:string
    fspNoteCw:string
    fspJsonParam:string
    isSpecific:boolean
    flxSpecificMessage:string
    hasSpecificMessage:boolean
    excludedStatutCompactGroup:Array<number>
    excludedDispo:Array<number>
    excludedMarque:Array<number>
    excludedTransporter:Array<number>
    partnerIds:Array<number>
    metaIds:Array<number>
    flxDownloadUrls:Array<string>
    linkToCsvFeed:string
    followers:Array<AloPersonne>
    pfeIds:Array<number>
    flxDirectBuildUrl:string
}

export const getDefaultAloFlux = ():AloFlux => {
    return {
        ...getDefaultAloBase(),
        ensId:0,
        bldId:-1,
        tmoId:0,        
        flxIsPortage:false,
        flxOffreTyp:TypeOffre.PrincipalStored,
        flxCatalogTyp:ExportCatalogType.Offers,
        flxPriorite:0,
        flxRestrictedFlag:'none',
        flcMercurialScope:'Default',
        flcMercurialMode:'Default',
        flxIsDisabled:false,
        flxCompressionMode:FluxCompressionMode.DirectGZipOnly,
        flcMinStockNb:0,
        flcMinRtb:0,
        flcExcludeRtbNullOn:false,
        flcExcludePxbOn:false,
        flcFiltreEntrepot:0,
        flcFiltreSeg:0,
        flcExcludedCodicStr:'',
        flcParamMaxPhotos:0,
        fspKey:'',
        fspContactClient:'',
        fspContactDarty:'',
        fspNoteCw:'',
        fspJsonParam:'{}',
        isSpecific:false,
        flxSpecificMessage:'',
        hasSpecificMessage:false,
        excludedStatutCompactGroup:[],
        excludedDispo:[],
        excludedMarque:[],
        excludedTransporter:[],
        partnerIds:[],
        metaIds:[],
        flxDownloadUrls:[],
        linkToCsvFeed:'',
        followers:[],
        pfeIds:[],
        flxDirectBuildUrl:''
    }
}

export const cleanAloFlux = (flux:AloFlux) => {
    if(!flux) return    
    if(!flux.id) delete flux.id
    if(!flux.bldId) delete flux.bldId    
    if(!flux.ensId) delete flux.ensId
    if(!flux.tmoId) delete flux.tmoId
}

